import React, {useEffect, useState} from 'react';
import { Modal } from 'antd';
import axios from '../Common/axios';
import InfoTableAsset from './InfoTableAsset';
import {assetColumnData, assetColumnDataFix} from './columns';
import {getFindInfoAssetListData, postSaveVaAssetData} from '../../pages/Common/api';
import { fieldRulesTab, validate , addAssetErrorKey} from '../Common/validationObj';

function InfoAsset({reportId, reportInfo}) {

    const [companyCode, setCompanyCode] = useState('');
    const [dataSource, setDataSource] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isDataChange, setIsDataChange] = useState(false);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const titleName="자산 수정";
    
    useEffect(() => {
        //자동조회
        if(reportId) {
            findInfoAssetListData();
        }
    }, []);

    useEffect(() => {
        if(reportInfo) {
            setCompanyCode(reportInfo.com_cd);
        }
    }, [reportInfo]);

    // 정보 변경시 재조회
    useEffect(() => {
        if(isDataChange) {
            findInfoAssetListData();
        }
    }, [isDataChange]);

    const findInfoAssetListData = () => {
        // 보고서ID 필수조건 체크
        if (reportId == '') {
            Modal.info({title:titleName, content:"Report ID가 누락되었습니다."});
            return;
        }

        setIsLoading(true);
        setIsDataChange(false);
        axios.get(getFindInfoAssetListData(reportId))
            .then((response) => {
                //console.log(response);
                setIsLoading(false);

                // const ret = response.data.map((row)=>{
                //     row['depart_nm']='000';
                //     return row;
                // });
                // let okTemp=setDataSource(ret);
                
                let okTemp=setDataSource(response.data);
                //if(response.data.totalCount == 0) {
                //    Modal.info({title: "조회된 결과가 없습니다.", okText:"닫기"});
                //} 
            })
            .catch((error) => {
                Modal.error({title:titleName, content:error.message})
                setIsLoading(false);
            });
    };

    // 저장 클릭 시
    const onClickSaveHandler = (saveData) => {

        // 변경건이 있으면 추가
        if(saveData.length > 0) {
            saveInfoAssetList(saveData);
        } else {
            Modal.info({title:titleName, content:"변경된 데이타가 없습니다.", okText:"Close"});
        }

    }

    // 자산정보 등록/수정/삭제 API
    const saveInfoAssetList = (saveData) => {
        setIsDataChange(false);
        // axios.post(postSaveVaAssetData(), {reportId : reportId, saveData : saveData}, {logCompany : companyCode, logParam : reportId})
        // .then((response) => {
        //     if(response.data.message == '성공적으로 처리되었습니다.') {
        //         Modal.info({title: response.data.message, okText:"Close"});
        //         setIsDataChange(true);
        //         findInfoAssetListData();
        //         return true;
        //     } else {
        //         Modal.info({title: response.data, okText:"Close"});  
        //     }
        // })
        // .catch((error) => {
        //     Modal.info({title: "Error : "+error, okText:"Close"});
        // });
        const checkData = async() => {
            for(let item of saveData){
                if(item.operation === "D") return "";
                for (let key in fieldRulesTab) {
                    const errormsg =  await validate(item[key], fieldRulesTab[key]);
                    if (errormsg.length > 0) {
                        return [key, errormsg[0]];
                    }
                }
            };
            return "";
        }

        checkData().then(
            errormsg => {
                if(errormsg.length > 0){
                    Modal.info({ title:titleName, content:"다음과 같은 입력 오류가 빌생 [ "+addAssetErrorKey[errormsg[0]]+" : "+errormsg[1]+" ]", okText: "Close" });
                    // alert("다음과 같은 입력 오류가 빌생 [ "+addAssetErrorKey[errormsg[0]]+" : "+errormsg[1]+" ]");
                    return;
                }
                
                axios.post(postSaveVaAssetData(), {reportId : reportId, saveData : saveData}, {logCompany : companyCode, logParam : reportId})
                .then((response) => {
                    if (response.data.status === 'success') {
                        //자산 관리 메뉴에서 자산등록 API 전송 규약
                        Modal.info({
                            title:titleName, content:"자산이 수정 되었습니다.", okText: "Close", onOk() {
                                setIsDataChange(true);
                            }
                        });
                        findInfoAssetListData();
                    } else {
                        //취약점 분석 메뉴에서 자산등록 API 전송 규약
                        Modal.info({
                            title:titleName, content:response.data.message, okText: "Close", onOk() {
                                setIsDataChange(true);
                            }
                        });
                    }
                }).catch((error) => {
                    Modal.error({ title:titleName, content:error.message, okText: "Close" });
                });
        });        
    };

    // 팝업에서 업로드 후 재조회
    const onReloadHandler = () => {
        //재조회
        findInfoAssetListData();
    }
    /** -------------------------------------------------------------------------- **/
    return (
        <>
            <div className='tab_content'>
                <InfoTableAsset
                    data={dataSource} 
                    columnData={assetColumnData}
                    rowKey="asset_cd"
                    selectedRowKeys={selectedRowKeys}
                    setSelectedRowKeys={setSelectedRowKeys}
                    reportId={reportId}
                    reportInfo={reportInfo}
                    infoType={'asset'}
                    assetTypeComCd={reportInfo.com_cd}
                    isLoading={isLoading} 
                    onClickSaveHandler={onClickSaveHandler}
                    onReloadHandler={onReloadHandler}
                    assetTypeOrg={reportInfo.asset_type}
                    rowIndex="asset_cd" />
            </div>
        </>
    );
}

export default InfoAsset;